import React, { useEffect, useState } from 'react';
import LinkCard from '../LinkCard/LinkCard';
import Modal from 'react-modal';
import { useNavigate, useParams } from "react-router-dom";
import './LinkPage.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { useSubdomain } from '../../utils/SubdomainUtils';
import { SpinnerCircular } from 'spinners-react';
import { Helmet } from 'react-helmet';

library.add(fab, fas);

function LinkPage() {
  const [config, setConfig] = useState(null);

  const navigate = useNavigate();
  const namespace = useSubdomain();
  const { productId } = useParams();

  useEffect(() => {
    fetch(`/config/${namespace}/default.json`)
      .then(response => response.json())
      .then((defaultConfig) => {

        if (productId) {
          fetch(`/config/${namespace}/pages/${productId}.json`)
            .then(response => response.json())
            .then((productConfig) => {
              const merged = { ...defaultConfig, ...productConfig };
              setConfig(merged);
            })
            .catch(error => {
              console.error('Error fetching product config:', error);
              navigate("/404");
            });
        } else {
          setConfig(defaultConfig)
        }
      })

      .catch(error => console.error('Error fetching default config:', error));
  }, []);

  Modal.setAppElement('#root');

  if (!config) {
    return <div className="loading"><SpinnerCircular color='white' /></div>;
  }

  const backgroundContainerStyle = {
    backgroundImage: `url(${config.product.image})`,
    backgroundSize: '150%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    height: '100%',
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: -1,
    filter: 'blur(50px) brightness(0.75)',
    opacity: 0.7
  };


  return (
    <div className="link-page">
      <Helmet>
        <meta property='og:title' content={config.product.title + " Promopool"} />
        <meta property='og:description' content={"Shared by " + config.brand.name} />
        <meta property='og:image' content={config.product.image} />
        <title>{config.product.title} - Promopool</title>
      </Helmet>
      {config.product.image &&
        <div style={backgroundContainerStyle}></div>}
      <div className="container">
        {config.brand.logo &&
        <div className="logo">
          <img src={config.brand.logo} alt={config.brand.name + " logo"}/>
        </div> }
        {config.product &&
          <div className="product">
            <img className="image" src={config.product.image} alt="Cover art" />
            <h1 className="title">{config.product.title}</h1>
          </div>}
        <div className="content">
          {config.links.map((link, index) => (
            <LinkCard
              key={index}
              link={link}
            />
          ))}
        </div>
      </div>
      <div className="footer">
        <p className="copyright">&copy; {new Date().getFullYear()} {config.brand.name}</p>
        <p className="subline">All rights reserved</p>
      </div>
    </div>
  );
}

export default LinkPage;
